const csrContactTypeEnum = {
    "PrimaryCSR" : 0,
    "BackupCSR" : 10,
    "SalesRep" : 20
}

export default csrContactTypeEnum; 